import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isValidate: false,
  isRefund: false,
  isPrint: false,
  isUpload: false,
  isRefundFinal: false,
  isStorageModal: false,
  isPassportCheck: false,
  isKioskRefundModal: false,
  isPaymentReady: false,
  isDuplicateRefund: false,
};

const refundSlice = createSlice({
  name: 'validate',
  initialState,
  reducers: {
    validateReset: () => initialState,
    passportValidateState: (state, action) => {
      state.isValidate = action.payload;
    },
    refundValidateState: (state, action) => {
      state.isRefund = action.payload;
    },
    printValidateState: (state) => {
      state.isPrint = true;
    },
    uploadValidateState: (state) => {
      state.isUpload = true;
    },
    refundFinalValidateState: (state) => {
      state.isRefundFinal = true;
    },
    storageModalState: (state, action) => {
      state.isStorageModal = action.payload;
    },
    passportCheckState: (state, action) => {
      state.isPassportCheck = action.payload;
    },
    kioskRefundModalState: (state, action) => {
      state.isKioskRefundModal = action.payload;
    },
    paymentReadyState: (state, action) => {
      state.isPaymentReady = action.payload;
    },
    duplicateRefundModalState: (state, action) => {
      state.isDuplicateRefund = action.payload;
    },
  },
});

export const {
  validateReset,
  passportValidateState,
  refundValidateState,
  printValidateState,
  uploadValidateState,
  refundFinalValidateState,
  storageModalState,
  passportCheckState,
  kioskRefundModalState,
  paymentReadyState,
  duplicateRefundModalState,
} = refundSlice.actions;
export default refundSlice.reducer;
